import { createConnect } from './connect';
export var connect = createConnect();
export { createConnect };
